import _ from 'lodash';
import DefaultBrandMap from '../../constants/default-information.map';
import SupportedLanguagesMap from '../../constants/supported-locale.map';
import { getSupportedLocale } from '../../../utilities/locale';
import DomainToLocaleMap from '../../constants/domain-to-locale.map';

const getLanguage = () => {
  return DefaultBrandMap.language;
};

const getLocaleFromHeader = (metaInfo) => {
  let locale;
  const supportedLocaleKeys = Object.keys(SupportedLanguagesMap);
  _.findIndex(supportedLocaleKeys, (key) => {
    if (metaInfo && metaInfo.toLowerCase().includes(`${key}`)) {
      locale = key;
      return true;
    }
    return false;
  });
  return locale;
};

const getLocale = (metaInfo, host) => {
  let { locale } = DefaultBrandMap;
  locale = getLocaleFromHeader(metaInfo);
  if (!locale && !(metaInfo || '').includes('linfo')) {
    locale = DomainToLocaleMap[host]
      ? DomainToLocaleMap[host].toLowerCase()
      : DefaultBrandMap.locale;
    return locale;
  }
  if ((metaInfo || '').includes('linfo')) {
    locale = getSupportedLocale(metaInfo);
  }
  return locale;
};

export { getLanguage, getLocale };
